<template lang="pug">
  .container-login
    h1.align-center 富慧通
    .loginBox
      el-tabs(v-model.trim="tab", stretch, v-loading="loading", :element-loading-fullscreen="false")
        el-tab-pane(label="登录", name="login")
          el-input(v-model.trim="loginForm.uname", placeholder='用户名',auto-complete="off")
          el-input(type="password", v-model.trim="loginForm.passwd",placeholder='密码',@keyup.enter.native="login()",auto-complete="off")
          el-button(type="primary", @click="login()", :disabled="loading").login-btn 登录
          router-link(to="/forgetPassword").forgetPassword 忘记密码？
        el-tab-pane(label="注册", name="reg")
          el-input(v-model.trim="regForm.uname", placeholder='用户名',auto-complete="off")
          el-input(type="password", v-model.trim="regForm.passwd", placeholder='密码长度至少为 8 位', auto-complete="off")
          el-input(type="password", v-model.trim="regForm.confirm_passwd", placeholder='重复输入密码', @keyup.enter.native="reg()", auto-complete="off")
          el-button(type="primary", @click="reg()", :disabled="loading").login-btn 注册
      div(class="ie",v-if='!(isChromeBrowe || isFirefoxBrowe)') 
        span 建议使用chrome、firefox浏览器获取最佳体验。点击下载：
        a(href="https://www.google.cn/chrome/") chrome
        a(href="http://www.firefox.com.cn/") firefox

    footer.container-copyright-login
      .copyright-content ©2018-2021Guangzhou ThinkinPower Internet Technology Co., Ltd. 版权所有 广州市思力智慧互联网科技有限公司
      .copyright-content 粤ICP备16101578号 粤公网安备44010602001961号
    //- el-dialog(title="关于系统升级维护的公告" :visible="isShow" width="50%" :center="true" class="gl-tip")
    //-     div
    //-         div 尊敬的用户：
    //-         p &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为更好的服务广大用户，我司将于2020年6月12日下午14:00至23:59进行系统升级维护。由此给您带来的不便，我们深表歉意，并将尽快恢复对您的服务，衷心感谢您对我司的理解和支持！
    //-         .txt-right 广州市思力智慧互联网科技有限公司
    //-         .txt-right 2020年6月12日
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      tab: "login",
      loginForm: {
        uname: "",
        passwd: "",
      },

      regForm: {
        uname: "",
        passwd: "",
        confirm_passwd: "",
      },

      loading: false,
      isShow: (() => {
        if (
          Math.round(new Date() / 1000) > 1591941600 &&
          Math.round(new Date() / 1000) < 1591977600
        ) {
          //   localStorage.setItem("verify", 0);
          if (this.$route.query.verify && this.$route.query.verify == 1) {
            // localStorage.setItem("verify", 1);
            return false;
          } else {
            return true;
          }
        } else {
          //   localStorage.setItem("verify", 1);
          return false;
        }
      })(),
      isChromeBrowe: navigator.userAgent.indexOf("Chrome") > -1,
      isFirefoxBrowe: navigator.userAgent.indexOf("Firefox") > -1,
    };
  },
  computed: {
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },

  methods: {
    login(toReg = false) {
      // 例如从H5登陆登陆个人高级钱包

      this.loading = true;

      this.$store
        .dispatch("LOGIN", this.loginForm)
        .then(() => {
          const target = toReg
            ? this.isMobile
              ? "/reg-mobile/2"
              : "/reg/2"
            : this.isMobile
            ? "/main-mobile"
            : "/main";
          this.$router.replace(target);
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `登录失败：${code}：${msg}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    reg() {
      if (this.regForm.passwd.length < 8) {
        this.$message({
          type: "warning",
          message: `密码长度至少为 8 位`,
        });
        return;
      }
      if (this.regForm.passwd !== this.regForm.confirm_passwd) {
        this.$message({
          type: "warning",
          message: `两次输入的密码不一致`,
        });
        return;
      }

      this.loading = true;

      this.$store
        .dispatch("REGISTRY", this.regForm)
        .then(() => {
          this.loginForm.uname = this.regForm.uname;
          this.loginForm.passwd = this.regForm.passwd;
          this.login();
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `注册失败：${code}：${msg}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
@import (reference) "../assets/general";

.container-login {
  .flex(center, center, column);
  .max-width;
  .max-height;

  background: url("../assets/bg_login.jpg") center center no-repeat;
  background-size: cover;

  .ie {
    // border: 1px solid red;
    margin: 8px 20px;
    font-size: 14px;
    color: #666;
    a {
      margin-right: 14px;
    }
  }

  .login-title {
    font-size: 36px;
    font-weight: normal;
    color: @white;
    .align-center;
  }
  .loginBox {
    .border-box;
    width: 340px;
    margin: 2em auto;
    padding: 0 20px 20px;

    background: @white;
    border-radius: 4px;
  }

  .login-btn {
    .max-width;
  }

  .container-copyright-login {
    .border-box;
    .flex(center, space-between);
    .max-width;
    .align-center;
    .position-absolute;
    bottom: 0%;

    padding: 1em;
    font-size: 12px;
    color: @white;

    @media screen and (max-width: 500px) {
      .flex(center, space-between, column);
    }
  }

  .forgetPassword {
    font-size: 12px;
    margin: 0.5em 0;
    color: @background-blue;

    &:hover {
      color: @background-blue-active;
    }
  }

  .el-input {
    margin-bottom: 20px;
  }

  .loginBox .el-tabs__nav {
    margin-left: 0;
  }
}
</style>
